import React, { useState, useEffect } from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../../components/button/button';

interface TimerProps {
  onStartStop: () => void;
  onReset: () => void;
  onTimeChange: (time: number) => void;
}

export function Timer({ onStartStop, onReset, onTimeChange }: TimerProps) {
  const { t } = useTranslation();
  const [time, setTime] = useState(20);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let interval: any;
    if (isRunning) {
      onTimeChange(time);
      interval = setInterval(() => {
        if (time >= 0) {
          setTime((seconds) => (seconds > 0 ? seconds - 1 : seconds));
          onTimeChange(time);
        }
      }, 1000);
    }
    if (time === 0) {
      setIsRunning(false);
    }
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRunning, time]);

  const handleReset = () => {
    setTime(20);
    setIsRunning(false);
    onReset();
  };

  const handleStartStop = () => {
    onStartStop();
    setIsRunning(!isRunning);
  };

  return (
    <>
      <Grid sx={{ border: '1px solid #eeeeee', p: 2, mb: 2 }}>
        <Typography variant="h3">
          00:{time.toString().padStart(2, '0')}
        </Typography>
      </Grid>
      <Stack direction="row" spacing={2} sx={{ my: 1 }}>
        <Button
          color="success"
          variant="contained"
          onClick={handleStartStop}
          label={t('assessment.START')}
          size="large"
          type="button"
        />
        <Button
          color="info"
          variant="contained"
          onClick={handleStartStop}
          label={t('assessment.PAUSE')}
          size="large"
          type="button"
        />
      </Stack>
      <Stack direction="column" alignItems="center" sx={{ my: 1 }}>
        <Button
          color="error"
          variant="contained"
          onClick={handleReset}
          label={t('assessment.RESET')}
          type="button"
        />
      </Stack>
    </>
  );
}
